import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  type: '',
  elKey: null
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    setTradeDialog(state, action) {
      if (state.isOpen && state.elKey) {
        const el = document.getElementById(state.elKey);
        if (el) {
          el.remove();
        }
      }
      state.isOpen = action.payload.isOpen;
      state.type = action.payload.type;
      state.elKey = null;
    },
    setTradeElementKey(state, action) {
      state.elKey = action.payload;
    }
  }
});

export const { setTradeDialog, setTradeElementKey } = dialogSlice.actions;

const dialogReducer = dialogSlice.reducer;
export default dialogReducer;
